/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  SelectComponentsConfig,
} from 'react-select';

import { ClearIndicator } from './ClearIndicator';
import { Control } from './Control';
import { DropdownIndicator } from './DropdownIndicator';
import { IndicatorSeparator } from './IndicatorSeparator';
import { Input } from './Input';
import { MenuList, WrappedMenuList } from './MenuList';
import { MultiValueContainer } from './MultiValueContainer';
import { MultiValueRemove } from './MultiValueRemove';
import { Option } from './Option';

const createComponents = (
  isAsync: boolean,
): SelectComponentsConfig<any, any, any> => ({
  Control,
  Input,
  ClearIndicator,
  DropdownIndicator,
  IndicatorSeparator,
  MenuList: isAsync ? WrappedMenuList : MenuList,
  MultiValueContainer,
  MultiValueRemove,
  Option,
});

export const selectComponentsSync = createComponents(false);
export const selectComponentsAsync = createComponents(true);
